import React from "react";
import { Typography, Divider } from "antd";
import PlanCard from "./planCard";

const { Text } = Typography;

const OutboundCard = props => {
    const { outboundPlan, ...otherProps } = props;
    if (!outboundPlan) return null;
    const { basePrice: price, planDetails } = outboundPlan;
    const { header, subHeader, price: planPrice, volume, descriptions, footer } = planDetails;
    return (
        <PlanCard
            title={header || outboundPlan.planName}
            subTitle={subHeader}
            price={price}
            descriptions={descriptions}
            footer={footer}
            {...otherProps}
        >
            <div style={{ marginTop: "0.75rem" }}>
                <Text strong style={{ fontSize: "2.25rem" }}>
                    {planPrice}
                </Text>
                <Text type="secondary">{` /mo`}</Text>
            </div>
            <Divider style={{ margin: "0.5rem" }} />
            <div>
                <Text strong style={{ fontSize: "1.5rem" }}>
                    {volume}
                </Text>
                <Text type="secondary">{` emails/mo`}</Text>
            </div>
        </PlanCard>
    );
};

export default OutboundCard;
